<template>
  <div
    class="product-item"
    :class="{ active: isActive, detailPopup: isDetailPopup }"
    :data-productid="item.PRODUCT_ID"
    @click="selectProduct(item)"
  >
    <div v-show="isExtraRatioShow()" class="product-tag">
      +{{ extraRatio() }}
      <img class="ico" :src="extraCoinIco" alt="extra-ico" />
    </div>
    <div
      v-if="productExtraCoinDisplay.isOverride"
      class="product-tag product-tag--extra-coin"
    >
      +5%
      <img class="ico" :src="productExtraCoinDisplay.ico" alt="extra-ico" />
    </div>
    <div class="product-item-detail">
      <div class="left">
        <img
          class="product-img center"
          :src="isJpPlatform ? productDefaultIco : (item.PRODUCT_ICON || productDefaultIco)"
          alt="product-img"
        />
      </div>
      <div class="right">
        <p class="product-name">
          {{ getProductName(item) }}
        </p>
        <p class="product-price">
          {{ item.GAME_AMOUNT }}
          <template v-if="isPreProduct">{{ item.GAME_CURRENCY }}</template>
          <template v-else>{{ currency }}</template>
        </p>
        <!-- 2024.5.29运营需求: 庄恺杰 特殊处理371ROV添加首充赠送水晶提示 -->
        <!-- 2024.9.13运营需求: 丘子豪 特殊处理2日本江美添加首充额外加码元宝提示 -->
        <p v-if="showProductExtraCoin" class="double-tip" style="margin-top: 5px;">
          +{{ item.PRODUCT_EXTRA_COIN }} <img class="double-ico" :src="productExtraCoinIcon" alt="extra-ico" />
        </p>
        <p v-if="showProductExtraCoin" class="double-tip">{{ productExtraCoinTip }}</p>
      </div>
    </div>
    <em class="choose iconfont icon-choose active" v-if="isActive"></em>
    <em class="choose iconfont icon-choose" v-else></em>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import product from '@mixins/officialWebStore/product';
import productExtraCoin from '@mixins/officialWebStore/productExtraCoin';
import productName from '@mixins/product';
export default {
  name: 'ProductItem',
  mixins: [product, productExtraCoin, productName],
  props: ['item', 'selectItem', 'isPreProduct', 'isDetailPopup'],
  data() {
    return {
      productExtraCoinFromItem: true
    };
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      letter: state => state.letter,
      currency: state => state.showCurrency
    }),
    ...mapGetters(['extraCoinIco', 'isJpPlatform']),
    // 2024.9.13 运营需求：ROV东南亚版371、日本江美2 特殊处理展示首储额外加码
    showProductExtraCoin() {
      const showProductExtraCoinGames =[371, 2];
      return showProductExtraCoinGames.includes(+this.gameId) && this.item.PRODUCT_TAG && this.item.PRODUCT_EXTRA_COIN;
    },
    // 首充额外加码icon
    productExtraCoinIcon() {
      if (+this.gameId === 371) {
        return '//cdnimages.awselbcombine.com/public_images/one_image/2024/05/171584266376490469.png';
      }
      return this.extraCoinIco;
    },
    // 首充额外加码提示
    productExtraCoinTip() {
      if (+this.gameId === 2) {
        return '初回チャージ';
      }
      return 'for the first recharge';
    },
    isSfqh() {
      return +this.gameId === 343;
    },
    isKzys() {
      return +this.gameId === 314;
    },
    isSfojp() {
      return +this.gameId === 333;
    },
    isSlssr() {
      return +this.gameId === 294;
    },
    isCodemr() {
      return +this.gameId === 286;
    },
    isNotUseExtraRatioGame() {
      // 不使用接口返回EXTRA_RATIO字段展示加码比率的游戏 因为之前运营需求 单独提供了加码比率映射
      const notUseExtraRatioGameList = [343, 314, 333, 294, 286];
      return notUseExtraRatioGameList.includes(+this.gameId);
    },
    isActive() {
      if (this.isPreProduct || this.isDetailPopup) {
        return false;
      }
      return (
        this.item.PRODUCT_ID == this.selectItem.PRODUCT_ID &&
        this.item.CP_PRODUCT_ID == this.selectItem.CP_PRODUCT_ID
      );
    }
  },
  methods: {
    // 运营需求: 庄恺杰 台港澳空之要塞商品项加码比率调整特殊处理
    isExtraRatioShow() {
      return this.extraRatio() !== '0%';
    },
    extraRatio() {
      if (!this.isNotUseExtraRatioGame) {
        if (!this.item.EXTRA_RATIO) return '0%';
        return (parseFloat(this.item.EXTRA_RATIO) * 100).toFixed(0) + '%';
      }
      // 欧美斗罗3D商品项加码比率
      const slssrExtraRatioMap = {
        'slssr.app.package_4.99': '0%',
        'slssr.app.package_9.99': '0%',
        'slssr.app.package_19.99': '0%',
        'slssr.app.package_29.99': '10%',
        'slssr.app.package_49.99': '12%',
        'slssr.app.package_99.99': '15%'
      };
      // 全球空之要塞商品项加码比率
      const kzysExtraRatioMap = {
        'kzys.app.coin_6': '0%',
        'kzys.app.coin_30': '0%',
        'kzys.app.coin_68': '0%',
        'kzys.app.coin_98': '0%',
        'kzys.app.coin_128': '0%',
        'kzys.app.coin_198': '0%',
        'kzys.app.coin_328': '5%',
        'kzys.app.coin_648': '10%'
      };
      // 日本空之要塞商品项加码比率
      const sfojpExtraRatioMap = {
        'sfojp.app.stone_6': '0%',
        'sfojp.app.stone_30': '0%',
        'sfojp.app.stone_68': '0%',
        'sfojp.app.stone_98': '0%',
        'sfojp.app.stone_128': '0%',
        'sfojp.app.stone_198': '0%',
        'sfojp.app.stone_328': '5%',
        'sfojp.app.stone_648': '10%'
      };
      // 台港澳空之要塞商品项加码比率
      const sfqhExtraRatioMap = {
        'sfqh.app.coin_6': '0%',
        'sfqh.app.coin_30': '0%',
        'sfqh.app.coin_68': '0%',
        'sfqh.app.coin_98': '0%',
        'sfqh.app.coin_128': '0%',
        'sfqh.app.coin_198': '0%',
        'sfqh.app.coin_328': '5%',
        'sfqh.app.coin_648': '10%'
      };
      if (this.isSlssr) {
        return slssrExtraRatioMap[this.item.PRODUCT_ID] || '0%';
      }
      if (this.isKzys) {
        return kzysExtraRatioMap[this.item.PRODUCT_ID] || '0%';
      }
      if (this.isSfojp) {
        return sfojpExtraRatioMap[this.item.PRODUCT_ID] || '0%';
      }
      if (this.isSfqh) {
        return sfqhExtraRatioMap[this.item.PRODUCT_ID] || '0%';
      }
      // 休闲三消全球版隐藏加码标签（开启需移除此片段及更新配置加码道具图标icon）
      if (this.isCodemr) {
        return '0%';
      }
      return '10%';
    },
    selectProduct(item) {
      this.$emit('selectProduct', item);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.product-item {
  position: relative;
  box-sizing: border-box;
  width: 334px;
  cursor: pointer;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 30px;
  @include g-border(2px);
  &.detailPopup {
    border: unset;
    width: 100%;
    margin-bottom: 0;
    .choose {
      display: none;
    }
  }
  .product-tag {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 3px;
    top: 3px;
    font-size: 20px;
    color: #fff;
    padding: 0 10px;
    height: 27px;
    @include g-gradient-btn();
    border-radius: 6px;
    background-size: cover;
    box-sizing: border-box;

    .ico {
      display: inline-block;
      width: 24px;
      height: 20px;
      margin-left: 5px;
    }

    &--extra-coin {
      right: 120px;
    }
  }
  &-detail {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 37px 23px;
    box-sizing: border-box;
    .left {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 66px;
      height: 66px;
      background: #ebebeb;
      border-radius: 16px;
      flex-shrink: 0;
      .product-img {
        width: 50px;
        height: 48px;
        background-size: cover;
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 17px;
    }
    .product-name {
      font-size: 22px;
      color: $productName;
      margin-bottom: 5px;
      font-weight: normal;
    }

    .product-price {
      font-size: 28px;
      color: $btnBg;
      font-weight: bold;
    }
    .double-tip {
      display: flex;
      align-items: center;
      font-size: 20px;
      color: $productName;
      .double-ico {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
    }
  }
  .choose {
    display: block;
    position: absolute;
    right: 3px;
    bottom: 3px;
    font-size: 27px;
    color: #dddddd;
    &.active {
      color: $btnBg;
    }
  }
}

@media screen and (orientation: landscape) {
  .product-item {
    width: 279px;
    margin-right: 10px;
    &:nth-child(3n) {
      margin-right: 0;
    }
    .product-tag {
      font-size: 16px;
      height: 23px;

      .ico {
        display: inline-block;
        background-size: cover;
        width: 18px;
        height: 15px;
      }
      &--extra-coin {
        right: 100px;
      }
    }
    &-detail {
      padding: 30px 18px;

      .left {
        width: 56px;
        height: 56px;

        .product-img {
          width: 42px;
          height: 40px;
        }
      }
      .right {
        margin-left: 13px;
      }
      .product-name {
        font-size: 18px;
        margin-bottom: 13px;
      }

      .product-price {
        font-size: 22px;
      }
      .double-tip {
        font-size: 16px;
      }
    }
    .choose {
      font-size: 23px;
    }
  }
}
</style>
